export enum ThemeType {
  DEFAULT = 'default',
  DARK = 'dark',
  LIGHT = 'light',
  SECONDARY = 'secondary',
}

export const THEME_CONFIG = {
  [ThemeType.DEFAULT]: {
    background: '#0A6991',
    primaryColor: '#0A6991',
    borderColor: '#F2F2F2',
    backgroundError: '#FDECEA',
    errorBorder: '#F5C2C0',
    errorText: '#B3261E',
    white: '#FFFFFF',
    black: '#000000',
  },
  [ThemeType.DARK]: {
    background:
      'linear-gradient(120deg, #d7232e 0%, #1a4879 40%, #352123 65%, #0f0101 85%, #0f0101 100%)',
    primaryColor: '#352123',
    borderColor: '#BFA181',
    backgroundError: '#3A1B1B',
    errorBorder: '#7A3B3B',
    errorText: '#F4B4AF',
    white: '#FFFFFF',
    black: '#000000',
  },
  [ThemeType.LIGHT]: {
    background:
      'linear-gradient(135deg, #f44336 0%, #ff8a65 25%, #42a5f5 75%, #26c6da 100%)',
    primaryColor: '#f16a6a',
    borderColor: '#FFB3A0',
    backgroundError: '#FDECEA',
    errorBorder: '#F5C2C0',
    errorText: '#B3261E',
    white: '#FFFFFF',
    black: '#000000',
  },
  [ThemeType.SECONDARY]: {
    background: '#1e3a73',
    primaryColor: '#1e3a73',
    borderColor: '#4C6EB1',
    backgroundError: '#FDECEA',
    errorBorder: '#F5C2C0',
    errorText: '#B3261E',
    white: '#FFFFFF',
    black: '#000000',
  },
};

export const THEME_NAMES = {
  [ThemeType.DEFAULT]: 'Padrão',
  [ThemeType.DARK]: 'Neon Noturno',
  [ThemeType.LIGHT]: 'Claro',
  [ThemeType.SECONDARY]: 'Alternativo',
};
